import { JourneyTrack } from "../journey-track";
import { TrackInfo } from "../model/track-info";
import { TrackTypes } from "../model/track-types";
import { DomainOrigin } from "../../../domains/model/domain-origin";
import { TrackActionResult } from "../model/track-action-result";
import { DataOrigin } from "../../../../model/DataOrigin";
import { environment } from "../../../../../../environments/environment";
import { BirthCountryAction } from "./actions/birth-country-action";
import { MaritalStatusAction } from "./actions/marital-status-action";
import { ProfessionalAction } from "./actions/professional-action";
import { OriginIncomeAction } from "./actions/origin-income-action";
import { ContaIonDataParse } from "./util/conta-ion-data-parse";
import { CacheService } from "../../../comunicator-native/cache/v2/cache.service";
import { MobileMockData } from "./util/mobile-mock-data";

export class ContaIonTrack extends JourneyTrack {
  readonly originalTracks = [
    new TrackInfo("overview", ["status", "overview"]),

    new TrackInfo("document-name", ["personal-data", "document-name"]),
    new TrackInfo(
      "document-type",
      ["personal-data", "document-type"],
      undefined,
      { domainOrigin: DomainOrigin[environment.contaIonDomainOrigin] }
    ),
    new TrackInfo("document-number", ["personal-data", "document-number"]),
    new TrackInfo(
      "document-issuing",
      ["personal-data", "document-issuing"],
      undefined,
      { domainOrigin: DomainOrigin[environment.contaIonDomainOrigin] }
    ),
    new TrackInfo(
      "expedition-state",
      ["personal-data", "expedition-state"],
      undefined,
      { domainOrigin: DomainOrigin[environment.contaIonDomainCityOrigin] }
    ),

    new TrackInfo("parentage", ["personal-data", "parentage"]),
    new TrackInfo("nationality", ["personal-data", "nationality"], undefined, {
      domainOrigin: DomainOrigin[environment.contaIonDomainOrigin],
    }),

    new TrackInfo(
      "birth-country",
      ["personal-data", "birth-country"],
      undefined,
      {
        domainOrigin: DomainOrigin[environment.contaIonDomainCityOrigin],
        actionName: ActionList.BirthCountry,
      }
    ),
    new TrackInfo("birth-state", ["personal-data", "birth-state"], undefined, {
      domainOrigin: DomainOrigin[environment.contaIonDomainCityOrigin],
    }),
    new TrackInfo("birth-city", ["personal-data", "birth-city"], undefined, {
      domainOrigin: DomainOrigin.BrokerMobile,
    }),
    new TrackInfo("gender", ["personal-data", "gender"], undefined, {
      domainOrigin: DomainOrigin[environment.contaIonDomainOrigin],
    }),

    new TrackInfo(
      "marital-status",
      ["marital-status", "marital-status"],
      undefined,
      {
        domainOrigin: DomainOrigin[environment.contaIonDomainOrigin],
        actionName: ActionList.MaritalStatus,
      }
    ),
    new TrackInfo("spouse", ["marital-status", "spouse"], undefined, {
      dataOrigin: DataOrigin[environment.contaIonDomainCityOrigin],
    }),

    new TrackInfo("cep", ["address", "cep"], undefined, {
      dataOrigin: DataOrigin[environment.contaIonDataOrigin],
    }),
    new TrackInfo("address-completed", ["address", "completed"]),

    new TrackInfo("pep", ["professional-data", "pep"]),

    new TrackInfo(
      "origin-income",
      ["professional-data", "origin-income"],
      undefined,
      {
        domainOrigin: DomainOrigin[environment.contaIonDomainOrigin],
        actionName: ActionList.OriginIncome,
      }
    ),

    new TrackInfo(
      "profession",
      ["professional-data", "profession"],
      undefined,
      {
        domainOrigin: DomainOrigin[environment.contaIonDomainOrigin],
        actionName: ActionList.Profession,
      }
    ),

    new TrackInfo(
      "company-cnpj",
      ["professional-data", "company-cnpj"],
      undefined,
      { dataOrigin: DataOrigin[environment.contaIonDomainCityOrigin] }
    ),

    new TrackInfo("income-wealthincome", ["income", "income-wealthincome"]),
    new TrackInfo("income-patrimony", ["income", "patrimony"]),
    new TrackInfo("income-tax-residency", ["income", "tax-residency"]),
    new TrackInfo(
      "income-tax-residency-country",
      ["income", "tax-residency-country"],
      undefined,
      { domainOrigin: DomainOrigin[environment.contaIonDomainCityOrigin] }
    ),
    new TrackInfo("income-nif", ["income", "nif"]),
    new TrackInfo("income-date-tax-res", ["income", "date-tax-residency"]),
  ];

  track = [];

  constructor(private cacheNativeService: CacheService) {
    super();
    this.track = this.originalTracks;
  }

  public getName(): TrackTypes {
    return TrackTypes.CONTA_ION;
  }

  public getTrack(): TrackInfo[] {
    return this.track;
  }

  public loadData() {
    // MobileMockData.executeMockCall(1500);
    const data = this.cacheNativeService.getItemCommunicator();

    const timeout = new Promise((_, reject) => {
      setTimeout(() => {
        reject(new Error('Network timeout'));
      }, 2000);
    });

    return Promise.race([data, timeout])
      .then((value) => {
        return Promise.resolve(ContaIonDataParse.parseFromMobileData(value));
      })
      .catch((err) => {
        return Promise.reject(new Error(err));;
      });
  }

  public isUncoupled() {
    return true;
  }

  public executeAction(actionName, data): TrackActionResult {
    switch (actionName) {
      case ActionList.BirthCountry:
        return BirthCountryAction.execute(
          data,
          this.track,
          this.originalTracks
        );
      case ActionList.OriginIncome:
        return OriginIncomeAction.execute(
          data,
          this.track,
          this.originalTracks
        );
      case ActionList.Profession:
        return ProfessionalAction.execute(
          data,
          this.track,
          this.originalTracks
        );
      case ActionList.MaritalStatus:
        return MaritalStatusAction.execute(
          data,
          this.track,
          this.originalTracks
        );
    }
  }

  isEventComunicator() {
    return true;
  }

  isBackHeader() {
    return false;
  }
}

export enum ActionList {
  BirthCountry = "country",
  OriginIncome = "origin",
  Profession = "profession",
  MaritalStatus = "marital-status",
}
